const putSquareSize = (size) => ({
  width: size,
  height: size,
})

export default putSquareSize
